export default "__VITE_ASSET__CGauAFuQ__"